<div>
  <kal-calendar-header
    [isMultiView]="isMultiView"
    (updateMonth)="updateView($event)">

    <p (click)="changeCurrentView()">
      {{ currentPeriod }}
    </p>

  </kal-calendar-header>

  <kal-calendar-month #monthCalendar
                      [classesListBuilder]="classesListBuilder"
                      [hidden]="isMultiView"
                      [validator]="validator"
                      [selectedDate]="selectedDate"
                      [activatedDates]="activatedDates"
                      (datePicked)="pickDate($event)">
  </kal-calendar-month>

  <kal-calendar-multi-view *ngIf="isMultiView"
                             [displayedDate]="monthCalendar.currentDate"
                             [minYear]="minYear"
                             [maxYear]="maxYear"
                             (selectedDate)="monthCalendar.updateDate($event)">
  </kal-calendar-multi-view>
</div>
